import {
  WhiteLayerSettings,
  WhiteLayerStats,
} from "../../types/whiteLayer";

/**
 * First-pass stats builder for browser preview.
 * This keeps the math lightweight and easy to tune while we build the feature out.
 */
export function buildStats(settings: WhiteLayerSettings): WhiteLayerStats {
  const estimatedCoverage = clamp(
    Math.round(
      settings.whiteStrength * 0.55 +
        settings.fadeSupport * 0.18 -
        settings.darkReduction * 0.12 -
        settings.noiseCleanup * 0.1 -
        settings.edgeTightness * 2
    ),
    18,
    96
  );

  const estimatedDensity = clamp(
    Math.round(
      settings.whiteStrength * 0.62 +
        settings.fadeSupport * 0.1 -
        settings.darkReduction * 0.18 -
        settings.noiseCleanup * 0.08
    ),
    10,
    100
  );

  const estimatedFeel: WhiteLayerStats["estimatedFeel"] =
    estimatedCoverage >= 78 ? "Heavy" : estimatedCoverage >= 56 ? "Balanced" : "Light";

  const haloRisk: WhiteLayerStats["haloRisk"] =
    settings.edgeTightness <= 1
      ? "High"
      : settings.edgeTightness <= 2
        ? "Moderate"
        : "Low";

  return {
    estimatedCoverage,
    estimatedDensity,
    estimatedFeel,
    haloRisk,
  };
}

function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value));
}
